import { component as defineComponent } from 'flightjs';
import withChildComponents from 'flight-with-child-components';
import ContestWatchersAction from 'contest/ui/contest-watchers-action';
import ContestActions from 'contest/ui/contest-actions-dropdown';
import GuaranteeModal from 'contest/ui/contest-guarantee-modal';
import ContestMetaData from 'contest/ui/contest-metadata';
import Button from 'contest/ui/button';
import AutoSelectInput from 'app/ui/auto-select-input';
import PopupLink from 'app/ui/popup-link';
import DetachedDropdown from '@99designs/common/jquery-plugins/detached-dropdown';
import socialShareTracking from 'contest/ui/social-share-tracking';

var contestHeader = function() {
    this.dropdowns = [];

    this.attributes({
        dropdowns: '[data-detached-dropdown]',
        buttons: '[data-button]',
    });

    this.after('initialize', function() {
        this.initChildComponents();
    });

    this.initChildComponents = function() {
        this.attachChild(ContestWatchersAction, '[data-contest-watchers-action]');
        this.attachChild(ContestActions, '[data-contest-actions-dropdown]');
        this.attachChild(GuaranteeModal, '[data-contest-guarantee-modal]');
        this.attachChild(ContestMetaData, '[data-contest-metadata]');
        this.attachChild(AutoSelectInput, '[data-auto-select-input]');
        this.attachChild(PopupLink, '[data-popup-link]');
        this.attachChild(Button, '[data-button]');

        this.enableDropdowns();
        socialShareTracking();
    };

    this.enableDropdowns = function() {
        this.select('dropdowns').each(
            function(i, el) {
                this.dropdowns.push(new DetachedDropdown($(el)));
            }.bind(this)
        );
    };
};

export default defineComponent(contestHeader, withChildComponents);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/contest-header.js